import { render } from "./SubFamilyFilterSelectorCard.vue?vue&type=template&id=b01d3816&scoped=true"
import script from "./SubFamilyFilterSelectorCard.vue?vue&type=script&lang=js"
export * from "./SubFamilyFilterSelectorCard.vue?vue&type=script&lang=js"

import "./SubFamilyFilterSelectorCard.vue?vue&type=style&index=0&id=b01d3816&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b01d3816"]])

export default __exports__